import * as yup from 'yup';

import { shortDescriptionSchema } from '../../../../utils/shortDescription';

export const schema:any = yup.object().shape({
  jobDescription: yup.string().nullable().trim()
    .required('The Job Description field is required.'),
  shortDescription: shortDescriptionSchema,
});
